import { ref, type Ref } from 'vue'
import type { HblIUseFlyout } from '@/utils/types'

const flyoutState: Ref<boolean> = ref(false)
const flyoutContext: Ref<string> = ref('')

export function useFlyout (): HblIUseFlyout {
    const toggleFlyout = function (context: string) {
        flyoutContext.value = flyoutContext.value === context ? '' : context
        flyoutState.value = !flyoutState.value
    }

    const closeFlyout = function () {
        flyoutState.value = false
        flyoutContext.value = ''
    }

    return {
        flyoutState,
        flyoutContext,
        toggleFlyout,
        closeFlyout
    }
}
